import axios from 'axios'
import dayjs from 'dayjs'
import utils from './utils'
import context from './context'

export const loggedIn = () =>{ 
    return window.localStorage.getItem('token') ? true : false
}

export const commaFormat = value => {

    if(!value) return

    var nStr = value + ''
    nStr = nStr.replace( /\,/g, "")
    var x = nStr.split( '.' )
    var x1 = x[0]
    var x2 = x.length > 1 ? '.' + x[1] : ''
    var rgx = /(\d+)(\d{3})/

    while ( rgx.test(x1) ) {
        x1 = x1.replace( rgx, '$1' + ',' + '$2' )
    }

    return (x1 + x2).toLocaleString("fa")

}

const checkExpirationAndRefreshToken = async() => {
    const expiration = window.localStorage.getItem('expiration')
    const diff = dayjs(expiration).diff(dayjs(), 'hour')
    
    console.log(diff, 'difffffff')
    
    if( diff < 1 ){
        const res = await axios({ url: utils.urls.refreshToken, method: 'POST' , data: {refreshToken: window.localStorage.getItem('refreshToken')}})
            .catch(e => {
                console.log(e)
                console.log(e.message)
                context.setIsLoggedIn(false)
                window.localStorage.clear()

            })

        if(!res) return

        window.localStorage.removeItem('expiration')
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('refreshToken')

        window.localStorage.setItem('expiration', res.data.expiration)
        window.localStorage.setItem('token', res.data.token)
        window.localStorage.setItem('refreshToken', res.data.refreshToken)

        return
    }

    return

}

export const ajax = async ({ method, url, data, hasToken, token, snackbar, headers = {}, errmessage="خطا در دریافت اطلاعات"}) => {
    let headersObject = { ...headers}
    if(hasToken) {
        await checkExpirationAndRefreshToken()
        headers.Authorization = `Bearer ${window.localStorage.getItem('token')}`
    }
    if(token) headers.Authorization = `Bearer ${token}`

    const axiosObject = {
        url,
        method: method ? method : 'GET',
        headers
    }

    if (data) axiosObject.data = data

    const res = await axios(axiosObject, headersObject)
        .catch(e => {
            console.log(e)
            console.log(e.message)
            const message = e.response && e.response.data && e.response.message || errmessage
            snackbar(message, {variant: 'error'})
        })

    if(!res) return
    return res
}
